import React, { useState } from "react";

export const ProductSellingGroups = ({
  product,
  settings,
  showAddToCart = false,
  showHeader = false,
  layout = "tabs", // "inline" or "tabs"
  isInTile = false
}) => {

  const productPrice = product?.price / 100;

  const limit =  isInTile ? 1 : 10;

  let firstVariant: any = null;
  if (product?.variants?.length > 0) {
    firstVariant = product?.variants[0];
  }

  if (!product?.selling_plan_groups?.length) {
    return null;
  }

  const [activeTab, setActiveTab] = useState("subscribe");
  const handleTabClick = (tab) => setActiveTab(tab);

  const renderInlineLayout = () => (
    <div className="product-selling-groups__inline">
      {product.selling_plan_groups?.map((sellingPlanGroup, groupIndex) =>
        sellingPlanGroup.selling_plans?.slice(0, limit).map((sellingPlan, planIndex) => {
          // Extract the selling plan price adjustment value
          const priceAdjustment = sellingPlan.price_adjustments[0];
          let sellingPlanPrice: any = 0;

          if (priceAdjustment.value_type === "percentage") {
            sellingPlanPrice = (
              (product.price * (1 - priceAdjustment.value / 100)) /
              100
            ).toFixed(2);
          } else if (priceAdjustment.value_type === "fixed") {
            sellingPlanPrice = (
              (product.price - priceAdjustment.adjustmentValue.price.amount) /
              100
            ).toFixed(2);
          }

          return (
            <React.Fragment key={planIndex}>
              <div
                className="product-selling-groups__option"
                key={sellingPlan.id}
              >
                <input
                  type="radio"
                  name="subscription"
                  value={sellingPlan.id}
                  id={`plan-${sellingPlan.id}`}
                  className="product-selling-groups__radio"
                  x-on:click="sellingGroupSelected"
                  data-sellinggroup-price={sellingPlanPrice}
                  data-variant-id={firstVariant?.id}
                  defaultChecked={
                    (!isInTile && groupIndex === 0 && planIndex === 0) ||
                    (isInTile && groupIndex === 0 && planIndex === 0)
                  }
                  // checked={(!isInTile && groupIndex === 0 || planIndex === 0) && true}
                />

                <div className="product-selling-groups__details flex max-lg:flex-col gap-2 lg:items-center lg:justify-between w-full">
                  <label
                    htmlFor={`plan-${sellingPlan.id}`}
                    className="product-selling-groups__label b2"
                  >
                    <span>{sellingPlan.name}</span>

                    {!isInTile &&
                      <div className="flex">
                        {priceAdjustment.value_type === "percentage" && (
                          <span className="product-selling-groups__badge">
                            SAVE {priceAdjustment.value}%
                          </span>
                        )}
                        {priceAdjustment.value_type === "fixed" && (
                          <span className="product-selling-groups__badge">
                            {((product.price - priceAdjustment.adjustmentValue.price.amount) / product.price) * 100}%
                          </span>
                        )}
                      </div>
                    }
                  </label>

                  <div className="product-selling-groups__price">
                    {isInTile &&
                      <div className="is-in-tile max-lg:ml-2 flex">
                        {priceAdjustment.value_type === "percentage" && (
                          <span className="product-selling-groups__badge">
                            SAVE {priceAdjustment.value}%
                          </span>
                        )}
                        {priceAdjustment.value_type === "fixed" && (
                          <span className="product-selling-groups__badge">
                            {((product.price - priceAdjustment.adjustmentValue.price.amount) / product.price) * 100}%
                          </span>
                        )}
                      </div>
                    }

                    <div className="product-selling-groups__final-price b3__regular">
                      <span>
                        ${sellingPlanPrice}
                        <span className="product-selling-groups__monthly">
                          /{isInTile ? 'mth' : 'month'}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {isInTile && <div className="product-selling-groups__onetime-option">
                <div className="product-selling-groups__option">
                  <input
                      type="radio"
                      name="subscription"
                      x-on:click="sellingGroupSelected"
                      data-sellinggroup-price={product.price / 100}
                      data-variant-id={firstVariant?.id}
                      className="product-selling-groups__radio form-radio"
                      defaultChecked={isInTile && true}
                      // checked={isInTile && true}
                  />
                  <label
                      htmlFor="subscription"
                      className="product-selling-groups__label b2"
                  >
                    Buy Once
                  </label>
                  <span className="product-selling-groups__price b3__regular">
                    ${productPrice.toFixed(2)}
                  </span>
                </div>
              </div>}

            </React.Fragment>
          );
        }),
      )}
    </div>
  );

  const renderTabsLayout = () => (
    <div>
      <div className="product-selling-groups__tab-list">
        <div
          className={`product-selling-groups__tab subscription ${
            activeTab === "subscribe"
              ? "product-selling-groups__tab--active"
              : ""
          }`}
          onClick={() => handleTabClick("subscribe")}
        >
          Subscribe & Save
        </div>
        <div
          className={`product-selling-groups__tab one-time ${
            activeTab === "onetime" ? "product-selling-groups__tab--active" : ""
          }`}
          onClick={() => handleTabClick("onetime")}
        >
          One Time
        </div>
      </div>

      <div className="product-selling-groups__content">
        {activeTab === "subscribe" && (
          <div className="product-selling-groups__options">
            {renderInlineLayout()}
          </div>
        )}
        {activeTab === "onetime" && (
          <div className="product-selling-groups__onetime-option">
            <div className="product-selling-groups__option">
              <input
                type="radio"
                name="one-time"
                checked={activeTab === "onetime"}
                x-on:click="sellingGroupSelected"
                data-sellinggroup-price={product.price / 100}
                className="product-selling-groups__radio form-radio"
              />
              <label
                htmlFor="one-time"
                className="product-selling-groups__label b2"
              >
                Buy Once
              </label>
              <span className="product-selling-groups__price b3__regular">
                ${productPrice.toFixed(2)}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const LayoutComponent:any = 'ajax-cart-product-form';
  return (
    <div x-data="sellinggroups" className="product-selling-groups">
      {layout === "inline" ? renderInlineLayout() : renderTabsLayout()}
      {showAddToCart && (
        <div className="product-selling-groups__add-to-cart">
          <LayoutComponent class="product-selling-groups__form">
            <form
              action="/cart/add"
              id="product_form_id"
              className="product-selling-groups__form-inner product-form"
              noValidate
              data-prodify-product-form
            >
              <input type="hidden" name="id" value={product.variants[0]?.id} />
              <button name="add" className="product-selling-groups__button button button-tertiary">
                <span className="b2 atc-label">Add to Cart | ${productPrice.toFixed(2)}</span>
              </button>
            </form>
          </LayoutComponent>
        </div>
      )}
    </div>
  );
};
